import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { JobPage } from "@/features/hiring/JobPage";

const search = z.object({
  view: z.enum(["board", "table"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/hiring/$job")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { job } = Route.useParams();
  return <JobPage id={job} search={Route.useSearch()} />;
}
